import { createClient } from '@supabase/supabase-js'

// Try to import the package version
let supabaseVersion = 'unknown';
try {
  // This works in some bundlers, but may fail in CRA
  // @ts-ignore
  supabaseVersion = require('@supabase/supabase-js/package.json').version;
} catch (e) {
  console.warn('Could not import Supabase JS version:', e);
}
console.log('Supabase JS package version:', supabaseVersion);

console.log('Initializing Supabase client...');

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Configuration for Supabase - detectSessionInUrl must be true for OAuth
const supabaseClient = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,      // auto-refresh tokens to keep session active
    persistSession: true,        // persist sessions in local storage
    detectSessionInUrl: true     // MUST BE TRUE for Google OAuth to work
  }
});

console.log('Supabase client created with balanced auth config:', !!supabaseClient);

export const supabase = supabaseClient; 